import React, { useState, useEffect } from "react";
import { Card, Spin, Empty, Table, Tag } from "antd";
import { settlementService } from "../../../../api/enhancedApi";

const SalesRouteProfitabilityWidget = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    const fetchStats = async () => {
        setLoading(true);
        try {
            const response = await settlementService.getSalesRouteProfitabilityStats({ limit: 5 });
            // response.data is backend return: array of profit data
            setData(response.data);
        } catch (error) {
            console.error("Failed to fetch sales route profitability stats:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchStats();
    }, []);

    const columns = [
        {
            title: "航线",
            dataIndex: "route_name",
            key: "route_name",
            ellipsis: true,
        },
        {
            title: "收入",
            dataIndex: "revenue",
            key: "revenue",
            align: "right",
            render: (val) => val.toLocaleString("en-US", { style: "currency", currency: "USD" }),
        },
        {
            title: "利润",
            dataIndex: "profit",
            key: "profit",
            align: "right",
            render: (val) => <span style={{ color: val >= 0 ? "var(--status-success)" : "var(--status-error)" }}>{val.toLocaleString("en-US", { style: "currency", currency: "USD" })}</span>,
        },
        {
            title: "利润率",
            dataIndex: "margin",
            key: "margin",
            align: "right",
            render: (val) => <Tag color={val >= 0.1 ? "success" : val >= 0 ? "warning" : "error"}>{(val * 100).toFixed(1)}%</Tag>,
        },
    ];

    return (
        <div style={{ height: "100%", minHeight: "300px" }}>
            {loading ? (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                    <Spin />
                </div>
            ) : data.length > 0 ? (
                <Table dataSource={data} columns={columns} pagination={false} size="small" rowKey="report_name" />
            ) : (
                <Empty description="暂无盈利数据" />
            )}
        </div>
    );
};

export default SalesRouteProfitabilityWidget;
